var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container !max-w-[1200px]" }, [
    _c(
      "div",
      { staticClass: "flex flex-wrap" },
      [
        _c("div", { staticClass: "w-12/12" }, [
          _c(
            "div",
            { staticClass: "mt-4" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "flex flex-wrap justify-center roboto h-fit md:h-screen overflow-hidden",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "license-height-wrapper w-12/12 max-w-[1100px] md:flex justify-between",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "text-wrapper" },
                        [
                          _c("p", { staticClass: "bold mb-0 steps" }, [
                            _vm._v("Step 1 of " + _vm._s(_vm.totalSteps)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "h3",
                            {
                              staticClass: "mb-1/2 bold text-blue-dark md:mt-0",
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.webstoreContent.cartPage.choose_license
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.showContractDisclaimer && !_vm.hasContractExpired
                            ? _c(
                                "div",
                                {
                                  staticClass: "mb-1/2 text-base leading-tight",
                                },
                                [
                                  _c("div", {}, [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(_vm.contractDisclaimer) +
                                        "\n                  "
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isSafetyEventReviewActive
                            ? _c("div", { staticClass: "mb-1/2 text-base" }, [
                                _c(
                                  "div",
                                  { staticClass: "safety-event-review" },
                                  [
                                    _c("strong", [_vm._v("Please note: ")]),
                                    _vm._v(
                                      _vm._s(
                                        _vm.webstoreContent.cartPage.safety_event_review.replace(
                                          "$5",
                                          `$${_vm.safetyEventReviewPrice.toFixed(
                                            2
                                          )}`
                                        )
                                      ) + "\n                  "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.activeProductKey.includes("CM")
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "text-blue-default text-base font-bold no-underline mt-1/2 hover:no-underline cursor-pointer",
                                  on: {
                                    click: function ($event) {
                                      _vm.openLicense = !_vm.openLicense
                                    },
                                  },
                                },
                                [
                                  _c("Plus"),
                                  _vm._v(" "),
                                  _c("span", {}, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.webstoreContent.webstoreBody
                                            .license.link.text
                                        ) +
                                        "\n                "
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.openLicense
                            ? _c("LicensePopup", {
                                attrs: {
                                  content:
                                    _vm.webstoreContent.webstoreBody.license,
                                },
                                on: {
                                  close: function ($event) {
                                    _vm.openLicense = !_vm.openLicense
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "w-full md:w-6/12 pt-1 md:pt-0 md:px-1 md:overflow-y-scroll scroll-wrapper",
                        },
                        [
                          _c("LicenseSelection", {
                            on: {
                              "scroll-to": _vm.scrollTo,
                              "license-change": _vm.handleLicenseChange,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  ref: "bagStep1",
                  staticClass:
                    "quantity-wrapper flex flex-wrap justify-center roboto mt-3 md:mt-5 quantity-selection h-screen",
                  class: _vm.bagStep < 1 && "grayed",
                },
                [
                  _vm.bagStep < 1
                    ? _c("div", { staticClass: "cover-up" })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "w-12/12 max-w-[1100px] md:flex justify-between",
                    },
                    [
                      _c("div", { staticClass: "w-full md:w-5/12" }, [
                        _c("p", { staticClass: "bold mb-0 pt-1 steps" }, [
                          _vm._v("Step 2 of " + _vm._s(_vm.totalSteps)),
                        ]),
                        _vm._v(" "),
                        _c("h3", { staticClass: "bold text-blue-dark mt-0" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.webstoreContent.cartPage.quantityCopy
                              ) +
                              "\n              "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "offer-wrapper w-full md:w-6/12 md:p-1 md:pt-0 md:overflow-hidden",
                        },
                        [
                          _vm._l(
                            this.activeProductInfo.offerings,
                            function (offer_info, offer) {
                              return _c(
                                "div",
                                { key: offer, staticClass: "w-full" },
                                [
                                  offer_info.offerKey === _vm.activeOfferKey
                                    ? _c("ProductQuantity", {
                                        ref: _vm.cleanOfferKey(
                                          offer_info.offerKey
                                        ),
                                        refInFor: true,
                                        attrs: {
                                          type: "product",
                                          showImage: false,
                                          updateTotal: true,
                                          imageSource: offer_info.offerImage,
                                          productName:
                                            _vm.activeProductInfo.name,
                                          skuText:
                                            offer_info.productCodes.join(", "),
                                          salesPrice:
                                            _vm.activeProductInfo.offerings[
                                              offer
                                            ].salesPrice,
                                          defaultTerm:
                                            _vm.activeOffer.defaultPaymentTerm,
                                          currency: _vm.currencySymbol,
                                          maxPurchasableQuantity:
                                            offer_info.maxPurchasableQuantity,
                                          minPurchasableQuantity: 1,
                                          startingNumber:
                                            _vm.setInitialOfferQuantity,
                                          value: `${offer} Quantity`,
                                          maxError:
                                            _vm.webstoreContent.cartPage
                                              .max_quantity_error,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            }
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "button-wrapper flex justify-center pt-1",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "border-1 border-blue-default rounded-full text-xl font-bold text-blue-default py-1/2 px-2 cursor-pointer hover:bg-blue-default hover:text-white",
                                  class:
                                    _vm.cablesNeededCount !== 0
                                      ? "active"
                                      : "inactive",
                                  on: {
                                    click: function ($event) {
                                      _vm.scrollTo(
                                        _vm.doesOfferRequireCable(
                                          _vm.activeOfferKey
                                        )
                                          ? 2
                                          : 4
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.webstoreContent.cartPage.next
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        2
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _vm.doesOfferRequireCable(_vm.activeOfferKey)
                    ? _c("CableSelection", {
                        ref: "cable-selection",
                        staticClass: "roboto bagStep2",
                        attrs: {
                          addToCart: true,
                          "bag-step": _vm.bagStep,
                          productName: _vm.activeProductInfo.name,
                          totalSteps: _vm.totalSteps,
                          activeCableSelectionMethods:
                            _vm.activeCableSelectionMethods,
                        },
                        on: {
                          updateBagStep: _vm.updateBagStep,
                          "scroll-to": _vm.scrollTo,
                          "add-selection-method":
                            _vm.updateActiveCableSelectionMethods,
                          "remove-selection-method":
                            _vm.removeActiveCableMethod,
                          "update-bottom-bar": _vm.updateBottomBar,
                          "update-bottom-bar-action": _vm.updateBarActions,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("SelectionSummary", {
                ref: "selection-summary",
                attrs: {
                  submitButtonText: _vm.submitButtonText,
                  addToCartDisabled: _vm.addToCartDisabled,
                  totalSteps: _vm.totalSteps,
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("ActionBottomNav", {
          ref: "bottom-nav",
          attrs: {
            submitButtonText: _vm.submitButtonText,
            totalSteps: _vm.totalSteps,
            activeCableSelectionMethods: _vm.activeCableSelectionMethods,
            bottomNavIsShown: _vm.bottomNavIsShown,
            isOnCableSelection: _vm.isOnCableSelection,
          },
          on: {
            "scroll-to": _vm.scrollTo,
            "add-to-cart": _vm.addToCart,
            "add-selection-method": _vm.updateActiveCableSelectionMethods,
            "confirm-cables": _vm.confirmCables,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }